// Todo remove it's duplicated in frameworkr as well, make sure it's not exported in shared package.
export enum OAuth2AuthorizationMethod {
    HEADER = 'HEADER',
    BODY = 'BODY',
}